import { create } from "zustand";
import type { ServiceWithRelationsT } from "@/app/types/services";

interface ServicesFilterState {
  // State
  services: ServiceWithRelationsT[];
  filteredServices: ServiceWithRelationsT[];
  selectedCategory: string;
  searchQuery: string;
  isLoading: boolean;
  isInitialized: boolean;

  // Actions
  setServices: (services: ServiceWithRelationsT[]) => void;
  setSelectedCategory: (category: string) => void;
  setSearchQuery: (query: string) => void;
  clearFilters: () => void;
  filterServices: () => void;
}

export const useServicesFilterStore = create<ServicesFilterState>(
  (set, get) => ({
    // Initial state
    services: [],
    filteredServices: [],
    selectedCategory: "all",
    searchQuery: "",
    isLoading: false,
    isInitialized: false,

    // Actions
    setServices: (services) => {
      set({ services, filteredServices: services, isInitialized: true });
    },

    setSelectedCategory: (category) => {
      set({ selectedCategory: category });
      get().filterServices();
    },

    setSearchQuery: (query) => {
      set({ searchQuery: query });
      get().filterServices();
    },

    clearFilters: () => {
      set({
        selectedCategory: "all",
        searchQuery: "",
        filteredServices: get().services,
      });
    },

    filterServices: () => {
      const { services, selectedCategory, searchQuery } = get();
      let filtered = [...services];

      // Filter nach Kategorie
      if (selectedCategory && selectedCategory !== "all") {
        filtered = filtered.filter((service) =>
          service.categories.some(
            (category) => category.key === selectedCategory
          )
        );
      }

      // Filter nach Suchquery
      if (searchQuery.trim()) {
        const query = searchQuery.toLowerCase().trim();
        filtered = filtered.filter((service) => {
          const titleMatch = service.title.toLowerCase().includes(query);
          const subtitleMatch =
            service.sub_title?.toLowerCase().includes(query) || false;
          const categoryMatch = service.categories.some((category) =>
            category.label.toLowerCase().includes(query)
          );

          return titleMatch || subtitleMatch || categoryMatch;
        });
      }

      set({ filteredServices: filtered });
    },
  })
);
